import { render, staticRenderFns } from "./ajouterVente.vue?vue&type=template&id=73f9beb6"
import script from "./ajouterVente.vue?vue&type=script&lang=js"
export * from "./ajouterVente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports